import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocationService } from 'src/app/modules/route-planner/services/location/location.service';
import { MapService } from 'src/app/modules/route-planner/services/map/map.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { RoutePlannerFormComponent } from '../../route-planner-form.component';
import {
  map,
  Observable,
  of,
  Subscription,
  distinctUntilChanged,
  takeUntil,
  filter,
  take,
  combineLatest,
  startWith,
  debounceTime,
  Subject,
} from 'rxjs';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { LogService } from 'src/app/@shared/services/log/log.service';
import { RoutePlanning } from 'src/app/modules/route-planner/interfaces/route-planning/@route-planning.interface';
import { CarIntegratedForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/car-integrated-form';
import {
  LEG_OPTIONS,
  eLegOptions,
} from 'src/app/modules/route-planner/constants/leg-options.constants';
import {
  LEG_SECTIONS,
  eLegSection as eLegSections,
} from 'src/app/modules/route-planner/constants/leg-sections.constants';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { FormValidators } from 'src/app/@forms/validators/validators';
import { Router } from '@angular/router';
import { SourceDestinationResultsContainerComponent } from 'src/app/modules/route-planner/containers/route-planning/route-planning-results-container/source-destination-results-container/source-destination-results-container.component';
import { ParkAndRide } from 'src/app/modules/route-planner/interfaces/location/park-and-ride.interface';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { AddressAutoCompleteComponent } from '../source-destination-form/address-auto-complete/address-auto-complete.component';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { eTransportationOptions } from 'src/app/modules/route-planner/constants/transportation-options.constants';
import { eSortOptions } from 'src/app/modules/route-planner/constants/sort-options.constants';
import { RouteFiltersComponent } from '../source-destination-form/route-filters/route-filters.component';
import { SourceDestinationFiltersForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/filters/source-destination-filters-form';
import { eDepartureTimeOptions } from 'src/app/modules/route-planner/constants/departure-time-options.constants';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  ADDRESS,
  CAR_LEG_CHOICE_RADIO_GROUP_LABEL,
  DESTINATION,
  END_ON_CAR_DESC,
  FILTERING_AND_SORTING,
  FIND_A_ROUTE,
  FIRST_LEG_ON_CAR,
  LAST_LEG_ON_CAR,
  ORIGIN,
  PARKING_LOTS,
  PICK_STOP_CAR,
  ROUTE_PLANNING,
  SEARCH_DESTINATION,
  SEARCH_ORIGIN,
  SEARCH_STOP_POINT,
  START_ON_CAR_DESC,
  STOP_ADDRESS,
  STOP_TYPE,
  SWITCH_LOCATIONS,
  TRAIN_STATIONS,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';
import { FilterStateService, initialTransportationsValues } from 'src/app/modules/route-planner/services/filters/filter-state.service';
import { PlannerSurveyOrchestratorService } from 'src/app/modules/route-planner/services/survey/planner-survey-orchestrator.service';

@Component({
    selector: 'app-car-integrated-form',
    templateUrl: './car-integrated-form.component.html',
    styleUrls: ['./car-integrated-form.component.scss'],
    standalone: false
})
export class CarIntegratedFormComponent
  extends RoutePlannerFormComponent
  implements OnInit, OnDestroy {
  @Output() toggleSearchButton: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() toogleLoader: EventEmitter<boolean> = new EventEmitter<boolean>();

  private readonly initialCarIntegratedFormValues = {

    origin: null,
    destination: null,
    timeOpt: eDepartureTimeOptions.NOW,
    arrival: {
      date: new Date(),
      time: this.utilsService.getCurrentTime(),
    },
    departure: {
      date: new Date(),
      time: this.utilsService.getCurrentTime(),
    },
    options: {
      isAccessible: false,
      changes: true,
      transportations: [...initialTransportationsValues],
      sortBy: eSortOptions.FREQUENCY_AND_TRAVEL_TIME,
      maxTravelTime: 600,
      maxWalkTime: 120,
    },
    isFirstLeg: true,
    legOpt: null,
    legLocation: {
      parkAndRideLot: null,
      trainStation: null,
      legAddress: null,
    }
  }


  selectedLegAddress: Address;
  legAddresses: Observable<SelectOption<Address>[]>;
  legOptionsFormControl = new FormControl(eLegOptions.PARK_AND_RIDE);

  legOptions: Observable<SelectOption<eLegOptions>[]>;
  eLegOptions = eLegOptions;

  legSections: Observable<SelectOption<eLegSections>[]>;

  parkingLotsOptions: Observable<SelectOption<Address>[]>;
  trainStationsOptions: Observable<SelectOption<Address>[]>;
  filteredTrainStationsOptions: Observable<SelectOption<Address>[]>;
  filteredParkingLotsOptions: Observable<SelectOption<Address>[]>;
  private trainStationFilterText = new Subject<string>();
  private parkingLotFilterText = new Subject<string>();
  private isInitializing = true;

  appliedFilters: boolean = false;
  resubmittedWithoutFilters: boolean = false;

  // Flag to prevent multiple simultaneous searches
  private isSearching: boolean = false;
  // Flag to track if coordinates are being fetched
  private isFetchingCoordinates: boolean = false;
  // Counter for pending coordinate fetches
  private pendingCoordinateFetches: number = 0;

  originText: string;
  searchOriginText: string;
  destinationText: string;
  searchDestinationText: string;
  filterText: string;
  pickStopText: string;
  startOnCarText: string;
  endOnCarText: string
  stopTypeText: string;
  stopAddressText: string;
  searchStopText: string;
  trainStationsText: string;
  parkingLotsText: string;
  carLegRadioGroupLabel: string;
  switchLocationsText: string = SWITCH_LOCATIONS.hebrew;

  direction: Direction;

  // Define a subscription for filter state changes
  private filterSubscription: Subscription;

  constructor(
    fb: FormBuilder,
    locationsService: LocationService,
    queryParamsService: QueryParamsService,
    routePlanningService: RoutePlanningService,
    router: Router,


    private readonly utilsService: UtilsService,
    private readonly localStorageService: LocalStorageService,
    private readonly languageService: LanguageService,
    private readonly filterStateService: FilterStateService,
    private readonly plannerSurveyOrchestrator: PlannerSurveyOrchestratorService
  ) {
    super(
      eTab.CAR_INTERGRATED,
      'מצא לי מסלול',
      fb,
      locationsService,
      queryParamsService,
      routePlanningService,
      router,
      utilsService
    );

    this.routePlannerForm = fb.group({
      ...this.routePlannerForm.controls,
      origin: new FormControl<Address>(this.initialCarIntegratedFormValues.origin, FormValidators.required),
      destination: new FormControl<Address>(this.initialCarIntegratedFormValues.destination, FormValidators.required),
      timeOpt: new FormControl<eDepartureTimeOptions>(this.initialCarIntegratedFormValues.timeOpt),

      arrival: fb.group({
        date: new FormControl<Date>(this.initialCarIntegratedFormValues.arrival.date),
        time: new FormControl<string>(this.initialCarIntegratedFormValues.arrival.time, [FormValidators.sourceDestiationTimeValidator(() => this.routePlannerForm?.get('timeOpt')?.value,
          eDepartureTimeOptions.ARRIVAL, () => this.routePlannerForm?.get('arrival.date'))]),
      }),

      departure: fb.group({
        date: new FormControl<Date>(this.initialCarIntegratedFormValues.departure.date),
        time: new FormControl<string>(this.initialCarIntegratedFormValues.departure.time, [FormValidators.sourceDestiationTimeValidator(() => this.routePlannerForm?.get('timeOpt')?.value,
          eDepartureTimeOptions.DEPART, () => this.routePlannerForm?.get('departure.date'))]),
      }),

      options: fb.group({
        isAccessible: new FormControl<boolean>(this.initialCarIntegratedFormValues.options.isAccessible),
        changes: new FormControl<boolean>(this.initialCarIntegratedFormValues.options.changes),
        transportations: new FormControl<eTransportationOptions[]>(this.initialCarIntegratedFormValues.options.transportations),
        sortBy: new FormControl<eSortOptions>(this.initialCarIntegratedFormValues.options.sortBy),
        maxTravelTime: new FormControl<number>(this.initialCarIntegratedFormValues.options.maxTravelTime),
        maxWalkTime: new FormControl<number>(this.initialCarIntegratedFormValues.options.maxWalkTime),
      }),

      isFirstLeg: new FormControl<boolean>(this.initialCarIntegratedFormValues.isFirstLeg),
      legOpt: new FormControl<eLegOptions>(this.initialCarIntegratedFormValues.legOpt, FormValidators.required),

      legLocation: fb.group(
        {
          parkAndRideLot: new FormControl<Address>(this.initialCarIntegratedFormValues.legLocation.parkAndRideLot),
          trainStation: new FormControl<Address>(this.initialCarIntegratedFormValues.legLocation.trainStation),
          legAddress: new FormControl<Address>(this.initialCarIntegratedFormValues.legLocation.legAddress),
        },
        { validators: FormValidators.onlyOneFieldFilled }
      ),
    });
  }

  ngOnInit(): void {
    // Initialize flags
    this.isSearching = false;
    this.isFetchingCoordinates = false;
    this.pendingCoordinateFetches = 0;

    this.routePlannerForm.controls['origin'].valueChanges.subscribe(
      (val: Address) => this.setAddressQueryParam(val, 'org', 'oll')
    );
    this.routePlannerForm.controls['destination'].valueChanges.subscribe(
      (val: Address) => this.setAddressQueryParam(val, 'dest', 'dll')
    );

    // Sync address when user picks from the map overlay (one-shot Subject, no replay issues)
    this.routePlanningService.mapAddressPicked$.subscribe(({ field, address }) => {
      const controlName = field === 'leg' ? 'legLocation.legAddress' : field;
      const control = this.routePlannerForm.get(controlName);
      if (!control) return;
      control.patchValue(address);
    });

    // First, load the park and ride options
    this.getParkAndRideOpts();

    // Check if we're loading from a shared URL
    const params = this.queryParamsService.currentParams;
    const isCarRouteTab = params && params['tab'] === eTab.CAR_INTERGRATED;
    const isSharedUrl =
      params &&
      isCarRouteTab &&
      (params['org'] || params['dest'] || params['legOpt'] || params['leg']);

    if (isSharedUrl) {
      // We'll handle this in autofillQueryParams which will be called by the tab change subscription
      this.autofillQueryParams();
    }

    // Now autofill query params

    // Add query param handling for leg option changes
    this.routePlannerForm
      .get('legOpt')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.queryParamsService.setQueryParams({
          legOpt: value,
          tab: eTab.CAR_INTERGRATED,
          saveParams: true,
          stopOpen: value === eLegOptions.ADDRESS ? '1' : null,
        });
        this.resetLegLocationForm();
      });

    // Add query param handling for train station selection
    this.routePlannerForm
      .get('legLocation.trainStation')
      .valueChanges.pipe(
        distinctUntilChanged(),
        filter((value) => !!value)
      )
      .subscribe((value) => {
        // Find the index of the selected train station
        this.trainStationsOptions.pipe(take(1)).subscribe((options) => {
          const index = options.findIndex(
            (option) =>
              option.value?.coordinates?.lat === value?.coordinates?.lat &&
              option.value?.coordinates?.lng === value?.coordinates?.lng
          );

          // Include the index in the query parameter
          if (index !== -1) {
            this.queryParamsService.setQueryParams({
              trainStation: value?.coordinates
                ? `${value.coordinates.lat},${value.coordinates.lng}_${index}`
                : value,
              tab: eTab.CAR_INTERGRATED,
              saveParams: true,
            });
          } else {
            this.queryParamsService.setQueryParams({
              trainStation: value?.coordinates
                ? `${value.coordinates.lat},${value.coordinates.lng}`
                : value,
              tab: eTab.CAR_INTERGRATED,
              saveParams: true,
            });
          }
        });
      });

    // Add query param handling for parking lot selection
    this.routePlannerForm
      .get('legLocation.parkAndRideLot')
      .valueChanges.pipe(
        distinctUntilChanged(),
        filter((value) => !!value)
      )
      .subscribe((value) => {
        // Find the index of the selected parking lot
        this.parkingLotsOptions.pipe(take(1)).subscribe((options) => {
          const index = options.findIndex(
            (option) =>
              option.value?.coordinates?.lat === value?.coordinates?.lat &&
              option.value?.coordinates?.lng === value?.coordinates?.lng
          );


          // Include the index in the query parameter
          if (index !== -1) {
            this.queryParamsService.setQueryParams({
              parkAndRideLot: value?.coordinates
                ? `${value.coordinates.lat},${value.coordinates.lng}_${index}`
                : value,
              tab: eTab.CAR_INTERGRATED,
              saveParams: true,
            });
          } else {
            this.queryParamsService.setQueryParams({
              parkAndRideLot: value?.coordinates
                ? `${value.coordinates.lat},${value.coordinates.lng}`
                : value,
              tab: eTab.CAR_INTERGRATED,
              saveParams: true,
            });
          }
        });
      });

    // Add query param handling for leg address selection
    this.routePlannerForm
      .get('legLocation.legAddress')
      .valueChanges.pipe(
        distinctUntilChanged(),
        filter((value) => !!value)
      )
      .subscribe((value) => {
        // Set the leg address label and coordinates in the query params
        const queryParams: any = {
          leg: value?.addressDetails?.label || 'Address',
          tab: eTab.CAR_INTERGRATED,
          saveParams: true,
        };

        // Set the leg address coordinates in the query params
        if (value?.coordinates) {
          queryParams.lll = `${value.coordinates.lat},${value.coordinates.lng}`;
        }

        this.queryParamsService.setQueryParams(queryParams);
      });

    // === Apply filters from LocalStorage/FilterStateService ===
    const currentFilters = this.filterStateService.getCurrentFilters();
    if (!this.filterStateService.filtersAreDefault(currentFilters)) {
      this.appliedFilters = true;
      // Patch the "options" control with the stored filters.
      this.routePlannerForm.patchValue({ options: currentFilters });
    }

    // Subscribe to filter state updates (to update the appliedFilters flag or trigger any other actions)
    this.filterSubscription = this.filterStateService.currentFilters$.subscribe(
      (filters) => {
        this.appliedFilters =
          !this.filterStateService.filtersAreDefault(filters);
        // (Optionally, re-patch the form control if needed here.)
      }
    );
    // =========================================================

    // Check if we're loading from URL params - if so, delay allowing resets until initialization completes
    const hasTimeParam = !!this.queryParamsService.currentParams['time'];
    if (hasTimeParam) {
      // Allow date-time picker to initialize from URL params first
      setTimeout(() => {
        this.isInitializing = false;
      }, 200);
    } else {
      this.isInitializing = false;
    }

    this.routePlannerForm.controls['timeOpt'].valueChanges.subscribe((value) => {
      if (this.isInitializing) {
        return;
      }

      const departureTime = this.routePlannerForm.get('departure.time');
      const arrivalTime = this.routePlannerForm.get('arrival.time');

      departureTime.setValue(this.utilsService.getCurrentTime())
      arrivalTime.setValue(this.utilsService.getCurrentTime())

    });

    this.routePlannerForm.get('arrival.date')?.valueChanges.subscribe(() => {
      this.routePlannerForm.get('arrival.time')?.updateValueAndValidity();
    });

    this.routePlannerForm.get('departure.date')?.valueChanges.subscribe(() => {
      this.routePlannerForm.get('departure.time')?.updateValueAndValidity();
    });

    this.initializeMultiLanguageTexts();
    this.initializeTrainStationFiltering();
    this.initializeParkingLotFiltering();
  }

  private initializeTrainStationFiltering() {
    // Get all train stations once
    this.getParkAndRideOpts();
    
    // Create filtered options based on input text
    this.filteredTrainStationsOptions = combineLatest([
      this.trainStationsOptions,
      this.trainStationFilterText.pipe(
        startWith(''),
        debounceTime(100)
      )
    ]).pipe(
      map(([options, filterText]: [SelectOption<Address>[], string]) => {
        if (!filterText || filterText.trim() === '') {
          return options;
        }
        const searchText = filterText.toLowerCase().trim();
        return options.filter(option => 
          option.label.toLowerCase().includes(searchText)
        );
      })
    );
  }

  onTrainStationTextChange(text: string) {
    this.trainStationFilterText.next(text);
  }

  onTrainStationSelected(address: Address) {
    // Reset filter when option is selected
    this.trainStationFilterText.next('');
  }

  private initializeParkingLotFiltering() {
    // Get all parking lots once
    this.getParkAndRideOpts();
    
    // Create filtered options based on input text
    this.filteredParkingLotsOptions = combineLatest([
      this.parkingLotsOptions,
      this.parkingLotFilterText.pipe(
        startWith(''),
        debounceTime(100)
      )
    ]).pipe(
      map(([options, filterText]: [SelectOption<Address>[], string]) => {
        if (!filterText || filterText.trim() === '') {
          return options;
        }
        const searchText = filterText.toLowerCase().trim();
        return options.filter(option => 
          option.label.toLowerCase().includes(searchText)
        );
      })
    );
  }

  onParkingLotTextChange(text: string) {
    this.parkingLotFilterText.next(text);
  }

  onParkingLotSelected(address: Address) {
    // Reset filter when option is selected
    this.parkingLotFilterText.next('');
  }

  ngOnDestroy(): void {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.originText = ORIGIN[language.language];
      this.destinationText = DESTINATION[language.language];
      this.searchOriginText = SEARCH_ORIGIN[language.language];
      this.searchDestinationText = SEARCH_DESTINATION[language.language];
      this.filterText = FILTERING_AND_SORTING[language.language];
      this.pickStopText = PICK_STOP_CAR[language.language];
      this.startOnCarText = START_ON_CAR_DESC[language.language];
      this.endOnCarText = END_ON_CAR_DESC[language.language]
      this.stopTypeText = STOP_TYPE[language.language];
      this.stopAddressText = STOP_ADDRESS[language.language];
      this.searchStopText = SEARCH_STOP_POINT[language.language];
      this.trainStationsText = TRAIN_STATIONS[language.language];
      this.parkingLotsText = PARKING_LOTS[language.language];
      this.carLegRadioGroupLabel =
        CAR_LEG_CHOICE_RADIO_GROUP_LABEL[language.language];
      this.switchLocationsText = SWITCH_LOCATIONS[language.language];

      this.buttonTitle = FIND_A_ROUTE[language.language];

      const legSections = [...LEG_SECTIONS];
      legSections.forEach((section) => {
        switch (section.value) {
          case eLegSections.FIRST_LEG:
            section.label = FIRST_LEG_ON_CAR[language.language];
            break;
          case eLegSections.LAST_LEG:
            section.label = LAST_LEG_ON_CAR[language.language];
            break;
          default:
            section.label = FIRST_LEG_ON_CAR[language.language];
        }
      });
      this.legSections = of(legSections);

      const legOptions = [...LEG_OPTIONS];
      legOptions.forEach((option) => {
        switch (option.value) {
          case eLegOptions.ADDRESS:
            option.label = ADDRESS[language.language];
            break;
          case eLegOptions.PARK_AND_RIDE:
            option.label = PARKING_LOTS[language.language];
            break;
          case eLegOptions.TRAIN_STATIONS:
            option.label = TRAIN_STATIONS[language.language];
            break;
          default:
            option.label = ADDRESS[language.language];
        }
      });
      this.legOptions = of(legOptions);
    });
  }

  override onTabLeave() {
    this.isSearching = false;
    this.isFetchingCoordinates = false;
    this.pendingCoordinateFetches = 0;
    const initialForm = { ...this.initialCarIntegratedFormValues }
    initialForm.options.transportations = [...initialTransportationsValues]
    const userFilters = this.filterStateService.getUserSavedFilters()
    if (userFilters) {
      initialForm.options = { ...userFilters }
    }
    this.routePlannerForm.reset(initialForm)
    this.filterStateService.clearFilters();

  }

  override autofillQueryParams() {
    const params = this.queryParamsService.currentParams;
    let shouldSubmitForm = false;

    // Only process parameters if the current tab is car-route
    const isCarRouteTab = params && params['tab'] === eTab.CAR_INTERGRATED;
    if (!isCarRouteTab) {
      return;
    }


    // Don't autofill if we're already searching or fetching coordinates
    if (this.isSearching || this.isFetchingCoordinates) {

      return;
    }

    // Handle origin parameter
    if (!!params?.['org'] && !!params?.['oll']) {
      const coordinates = params['oll'].split('_');
      // Validate coordinates before setting them
      if (
        coordinates.length >= 2 &&
        !isNaN(parseFloat(coordinates[0])) &&
        !isNaN(parseFloat(coordinates[1]))
      ) {
        this.routePlannerForm.patchValue({
          origin: {
            addressDetails: {
              label: params['org'],
            },
            coordinates: {
              lat: parseFloat(coordinates[0]),
              lng: parseFloat(coordinates[1]),
            },
          },
        });
        shouldSubmitForm = true;
      } else {
        console.error(
          'Invalid origin coordinates in URL parameters:',
          params['oll']
        );
      }
    } else if (!!params?.['org']) {
      // If we have org but no coordinates, we'll try to use it anyway

      this.routePlannerForm.patchValue({
        origin: {
          addressDetails: {
            label: params['org'],
          },
        },
      });
      shouldSubmitForm = true;
    }

    // Handle destination parameter
    if (!!params?.['dest'] && !!params?.['dll']) {
      const coordinates = params['dll'].split('_');
      // Validate coordinates before setting them
      if (
        coordinates.length >= 2 &&
        !isNaN(parseFloat(coordinates[0])) &&
        !isNaN(parseFloat(coordinates[1]))
      ) {
        this.routePlannerForm.patchValue({
          destination: {
            addressDetails: {
              label: params['dest'],
            },
            coordinates: {
              lat: parseFloat(coordinates[0]),
              lng: parseFloat(coordinates[1]),
            },
          },
        });
        shouldSubmitForm = true;
      } else {
        console.error(
          'Invalid destination coordinates in URL parameters:',
          params['dll']
        );
      }
    } else if (!!params?.['dest']) {
      // If we have dest but no coordinates, we'll try to use it anyway

      this.routePlannerForm.patchValue({
        destination: {
          addressDetails: {
            label: params['dest'],
          },
        },
      });
      shouldSubmitForm = true;
    }

    // Handle isFirstLeg param
    if (params?.['isFirstLeg'] !== undefined) {
      const isFirstLeg =
        params['isFirstLeg'] === 'true' || params['isFirstLeg'] === true;
      this.routePlannerForm
        .get('isFirstLeg')
        .setValue(isFirstLeg, { emitEvent: true });
    }

    // Handle legOpt param
    if (params?.['legOpt']) {
      this.routePlannerForm
        .get('legOpt')
        .setValue(parseInt(params['legOpt']), { emitEvent: true });

      // For legOpt=2 (TRAIN_STATIONS), we need to ensure we have train stations loaded
      if (parseInt(params['legOpt']) === eLegOptions.TRAIN_STATIONS) {
        this.getParkAndRideOpts();
      }
    }

    // Handle leg address param
    if (params?.['leg'] && params?.['lll']) {


      // Check if legOpt is set to ADDRESS
      if (this.routePlannerForm.get('legOpt').value === eLegOptions.ADDRESS) {
        const coordinates = params['lll'].split(',');
        // Validate coordinates before setting them
        if (
          coordinates.length >= 2 &&
          !isNaN(parseFloat(coordinates[0])) &&
          !isNaN(parseFloat(coordinates[1]))
        ) {
          this.routePlannerForm.get('legLocation.legAddress').setValue(
            {
              addressDetails: {
                label: params['leg'],
              },
              coordinates: {
                lat: parseFloat(coordinates[0]),
                lng: parseFloat(coordinates[1]),
              },
            },
            { emitEvent: true }
          );
        } else {
          console.error(
            'Invalid leg address coordinates in URL parameters:',
            params['lll']
          );

          // Try to fetch coordinates for the leg address
          this.locationsService
            .searchAddress(params['leg'])
            .pipe(take(1))
            .subscribe(
              (response: ServiceResponse<Address[]>) => {
                if (response.data && response.data.length > 0) {
                  const address = response.data[0];


                  this.routePlannerForm.get('legLocation.legAddress').setValue(
                    {
                      addressDetails: {
                        label: params['leg'],
                      },
                      coordinates: address.coordinates,
                    },
                    { emitEvent: true }
                  );
                }
              },
              (error) =>
                console.error(
                  'Error fetching coordinates for leg address:',
                  error
                )
            );
        }
      }
    }

    // Handle train station param
    if (params?.['trainStation']) {

      // Check if trainStation is [object Object] or similar
      if (
        params['trainStation'] === '[object Object]' ||
        params['trainStation'].includes('object')
      ) {
        // We need to fetch train stations and select one
        this.getParkAndRideOpts();

        // We'll set a default or first train station later when data is loaded
        this.trainStationsOptions
          .pipe(
            filter((options) => options && options.length > 0),
            take(1) // Take only the first emission
          )
          .subscribe((options) => {
            if (options && options.length > 0) {

              this.routePlannerForm
                .get('legLocation.trainStation')
                .setValue(options[0].value, { emitEvent: true });
            }
          });
      } else if (params['trainStation'].includes(',')) {
        // Parse the parameter to check if it includes an index
        const parts = params['trainStation'].split('_');
        const coordinates = parts[0].split(',');
        const index = parts.length > 1 ? parseInt(parts[1]) : -1;

        if (
          coordinates.length >= 2 &&
          !isNaN(parseFloat(coordinates[0])) &&
          !isNaN(parseFloat(coordinates[1]))
        ) {
          // If we have an index, try to use it to select from options
          if (index >= 0) {
            this.getParkAndRideOpts();
            this.trainStationsOptions
              .pipe(
                filter((options) => options && options.length > 0),
                take(1)
              )
              .subscribe((options) => {
                if (options && options.length > index) {

                  this.routePlannerForm
                    .get('legLocation.trainStation')
                    .setValue(options[index].value, { emitEvent: true });
                } else {
                  // Fallback to using coordinates directly

                  this.routePlannerForm
                    .get('legLocation.trainStation')
                    .setValue(
                      {
                        coordinates: {
                          lat: parseFloat(coordinates[0]),
                          lng: parseFloat(coordinates[1]),
                        },
                        addressDetails: {
                          label: 'Train Station',
                        },
                      },
                      { emitEvent: true }
                    );
                }
              });
          } else {
            // No index, use coordinates directly
            this.routePlannerForm.get('legLocation.trainStation').setValue(
              {
                coordinates: {
                  lat: parseFloat(coordinates[0]),
                  lng: parseFloat(coordinates[1]),
                },
                addressDetails: {
                  label: 'Train Station',
                },
              },
              { emitEvent: true }
            );
          }
        }
      }
    }

    // Handle parking lot param
    if (params?.['parkAndRideLot']) {

      // Check if parkAndRideLot is [object Object] or similar
      if (
        params['parkAndRideLot'] === '[object Object]' ||
        params['parkAndRideLot'].includes('object')
      ) {
        // We need to fetch parking lots and select one
        this.getParkAndRideOpts();

        // We'll set a default or first parking lot later when data is loaded
        this.parkingLotsOptions
          .pipe(
            filter((options) => options && options.length > 0),
            take(1) // Take only the first emission
          )
          .subscribe((options) => {
            if (options && options.length > 0) {

              this.routePlannerForm
                .get('legLocation.parkAndRideLot')
                .setValue(options[0].value, { emitEvent: true });
            }
          });
      } else if (params['parkAndRideLot'].includes(',')) {
        // Parse the parameter to check if it includes an index
        const parts = params['parkAndRideLot'].split('_');
        const coordinates = parts[0].split(',');
        const index = parts.length > 1 ? parseInt(parts[1]) : -1;

        if (
          coordinates.length >= 2 &&
          !isNaN(parseFloat(coordinates[0])) &&
          !isNaN(parseFloat(coordinates[1]))
        ) {
          // If we have an index, try to use it to select from options
          if (index >= 0) {
            this.getParkAndRideOpts();
            this.parkingLotsOptions
              .pipe(
                filter((options) => options && options.length > 0),
                take(1)
              )
              .subscribe((options) => {
                if (options && options.length > index) {

                  this.routePlannerForm
                    .get('legLocation.parkAndRideLot')
                    .setValue(options[index].value, { emitEvent: true });
                } else {
                  // Fallback to using coordinates directly

                  this.routePlannerForm
                    .get('legLocation.parkAndRideLot')
                    .setValue(
                      {
                        coordinates: {
                          lat: parseFloat(coordinates[0]),
                          lng: parseFloat(coordinates[1]),
                        },
                        addressDetails: {
                          label: 'Park and Ride',
                        },
                      },
                      { emitEvent: true }
                    );
                }
              });
          } else {
            // No index, use coordinates directly
            this.routePlannerForm.get('legLocation.parkAndRideLot').setValue(
              {
                coordinates: {
                  lat: parseFloat(coordinates[0]),
                  lng: parseFloat(coordinates[1]),
                },
                addressDetails: {
                  label: 'Park and Ride',
                },
              },
              { emitEvent: true }
            );
          }
        }
      }
    }

    // If both origin and destination are set from URL parameters, submit the form after a delay
    if (shouldSubmitForm && !!params?.['org'] && !!params?.['dest']) {
      // Add a delay to ensure the application is fully initialized and data is loaded
      setTimeout(() => {
        // Only submit if we're not already searching or fetching coordinates
        if (!this.isSearching && !this.isFetchingCoordinates) {
          this.submitRoutePlannerForm();
        } else {

        }
      }, 1000); // Increased delay to allow for data loading
    }
  }

  private resetLegLocationForm() {
    const legLocationGroup = this.routePlannerForm.get(
      'legLocation'
    ) as FormGroup;

    // Clear query params when resetting
    this.queryParamsService.setQueryParams({
      trainStation: null,
      parkAndRideLot: null,
      legAddress: null,
    });

    legLocationGroup.reset({
      parkAndRideLot: null,
      trainStation: null,
      legAddress: null,
    });
  }

  private getParkAndRideOpts() {
    // Only recreate observables if they don't exist yet
    if (!this.parkingLotsOptions || !this.trainStationsOptions) {
      const language = this.languageService.getSelectedLanguage();
      const parkAndRideLotsObs$ = this.locationsService.getParkAndRideLots();
      this.parkingLotsOptions = parkAndRideLotsObs$.pipe(
        map((response: ServiceResponse<ParkAndRide[]>) => {
          const options: SelectOption<Address>[] = [];
          response.data
            .filter((lot: ParkAndRide) => !lot.isTrainStation)
            .forEach((lot: ParkAndRide) =>
              options.push({
                label: lot.name[language.symbol] || lot.name.he || '',
                value: { coordinates: { lat: lot.lat, lng: lot.lng }, addressDetails: { label: lot.name[language.symbol] || lot.name.he || '' } },
              })
            );
          return options.sort((a, b) => a.label.localeCompare(b.label));
        })
      );

      this.trainStationsOptions = parkAndRideLotsObs$.pipe(
        map((response: ServiceResponse<ParkAndRide[]>) => {
          const options: SelectOption<Address>[] = [];
          response.data
            .filter((lot: ParkAndRide) => lot.isTrainStation)
            .forEach((lot: ParkAndRide) =>
              options.push({
                label: lot.name[language.symbol] || lot.name.he || '',
                value: { coordinates: { lat: lot.lat, lng: lot.lng }, addressDetails: { label: lot.name[language.symbol] || lot.name.he || '' } },
              })
            );
          return options.sort((a, b) => a.label.localeCompare(b.label));
        })
      );
    }
  }

  // private getTrainStationOpts() {
  //   const trainStationsObs$ = this.scheduleService.getAllTrainStations()
  //      = trainStationsObs$.pipe(
  //     map((response: ServiceResponse<Stop[]>) => {
  //       const options: SelectOption<Address>[] = [];
  //       response.data.forEach((stop: Stop) => options.push({ label: stop.name, value: { coordinates: { lat: stop.lat, lng: stop.lng } } }));
  //       return options;
  //     })
  //   );
  // }

  override submitRoutePlannerForm() {


    // Prevent multiple simultaneous searches
    if (this.isSearching) {
      return;
    }

    this.isSearching = true;


    // Log the isFirstLeg value
    const isFirstLeg = !!this.routePlannerForm.get('isFirstLeg').value;

    // Check if we have at least origin and destination
    const hasOrigin = !!this.routePlannerForm.get('origin').value;
    const hasDestination = !!this.routePlannerForm.get('destination').value;

    if (this.routePlannerForm.valid || (hasOrigin && hasDestination)) {
      const routePlanningFormValues: CarIntegratedForm =
        this.routePlannerForm.value;
      LogService.logInfo(`RoutePlanningForm values`, routePlanningFormValues);
      const selectedTimeOpt = this.routePlannerForm.controls['timeOpt'].value;

      // For shared links, we might need to ensure legOpt is set
      if (
        !this.routePlannerForm.get('legOpt').value &&
        this.queryParamsService.currentParams?.['legOpt']
      ) {
        this.routePlannerForm
          .get('legOpt')
          .setValue(parseInt(this.queryParamsService.currentParams['legOpt']));

      }

      // Ensure the tab parameter is set for sharing
      this.queryParamsService.setQueryParams({
        tab: eTab.CAR_INTERGRATED,
        saveParams: true,
        isFirstLeg: !!routePlanningFormValues.isFirstLeg,
      });

      // Check if we need to fetch coordinates for origin or destination
      const needsOriginCoordinates =
        routePlanningFormValues.origin?.addressDetails?.label &&
        (!routePlanningFormValues.origin.coordinates ||
          !routePlanningFormValues.origin.coordinates.lat ||
          !routePlanningFormValues.origin.coordinates.lng);

      const needsDestinationCoordinates =
        routePlanningFormValues.destination?.addressDetails?.label &&
        (!routePlanningFormValues.destination.coordinates ||
          !routePlanningFormValues.destination.coordinates.lat ||
          !routePlanningFormValues.destination.coordinates.lng);

      // If we need to fetch coordinates, do that first and return
      if (needsOriginCoordinates || needsDestinationCoordinates) {

        // Set loading state to indicate we're working on it
        this.toggleSearchButton.emit(true);
        this.toogleLoader.emit(true);
        this.routePlanningService.updateLoadingState(true);

        // Set flag to indicate we're fetching coordinates
        this.isFetchingCoordinates = true;
        this.pendingCoordinateFetches = 0;

        if (needsOriginCoordinates) {
          this.pendingCoordinateFetches++;
          this.fetchCoordinatesForAddress(
            'origin',
            routePlanningFormValues.origin.addressDetails.label
          );
        }

        if (needsDestinationCoordinates) {
          this.pendingCoordinateFetches++;
          this.fetchCoordinatesForAddress(
            'destination',
            routePlanningFormValues.destination.addressDetails.label
          );
        }

        // The form will be resubmitted after coordinates are fetched
        // Reset the isSearching flag since we're not actually searching yet
        this.isSearching = false;
        return;
      }

      // Additional validation for coordinates
      if (!this.validateCoordinates(routePlanningFormValues)) {
        console.error('Invalid coordinates in form values, cannot submit form');
        this.toggleSearchButton.emit(false);
        this.toogleLoader.emit(false);
        this.isSearching = false;
        return;
      }

      // Set loading state
      this.toggleSearchButton.emit(true);
      this.toogleLoader.emit(true);
      this.routePlanningService.updateLoadingState(true);

      // Add a small delay to ensure data is loaded
      setTimeout(() => {
        const routesObs = this.getRoutePlanningObs(
          routePlanningFormValues,
          selectedTimeOpt
        );

        routesObs.subscribe({
          next: (routePlanningRes: ServiceResponse<RoutePlanning[]>) => {
            if (routePlanningRes.data && routePlanningRes.data.length > 0) {
              this.handleSuccessfullResponse(
                routePlanningRes,
                routePlanningFormValues
              );
            } else {
              this.resendWithoutFilters(
                routePlanningFormValues.origin,
                routePlanningFormValues.destination,
              );
            }
          },
          error: (error) => {
            console.error('Error in route planning:', error);
            this.toggleSearchButton.emit(false);
            this.toogleLoader.emit(false);
            this.routePlanningService.updateLoadingState(false);
            this.isSearching = false;
          },
        });
      }, 300);
    } else {
      console.warn('Form is invalid:', this.routePlannerForm.errors);

      // Log specific validation errors
      Object.keys(this.routePlannerForm.controls).forEach((key) => {
        const control = this.routePlannerForm.get(key);
        if (control && control.errors) {
          console.warn(`Control ${key} has errors:`, control.errors);
        }
      });

      this.isSearching = false;
    }
  }

  private handleSuccessfullResponse(
    routePlanningRes: ServiceResponse<RoutePlanning[]>,
    routePlanningFormValues: CarIntegratedForm
  ) {
    // Check if we got a placeholder response while fetching coordinates
    if (routePlanningRes.message === 'Fetching coordinates...') {
      return;
    }

    this.routePlannerForm.markAsPristine();
    this.toggleSearchButton.emit(false);
    this.toogleLoader.emit(false);
    this.routePlanningService.updateLoadingState(false);
    this.isSearching = false;

    this.routePlanningService._formSubject.next({
      formValues: routePlanningFormValues,
      results: routePlanningRes.data,
      resubmittedWithoutFilters: this.resubmittedWithoutFilters,
      leg: this.selectedLegAddress
    });

    this.routePlanningService._componentOverlaySub.next({
      componentType: SourceDestinationResultsContainerComponent,
      data: {
        closeCallbackFn: (resubmitForm) => {
          if (!!resubmitForm) {
            const currentFilters: SourceDestinationFiltersForm =
              this.filterStateService.getCurrentFilters();

            this.applyFilters(currentFilters);
            this.submitRoutePlannerForm();
          }
        },
      },
    });

    if (routePlanningRes.data?.length > 0) {
      this.plannerSurveyOrchestrator.scheduleSurveyAfterSearch({
        plannerScenario: 'od',
        originLocationId: routePlanningFormValues.origin?.locationId,
        destinationLocationId: routePlanningFormValues.destination?.locationId,
      });
    }
  }

  private resendWithoutFilters(origin: Address, destination: Address) {
    this.resubmittedWithoutFilters = true;
    this.routePlannerForm.reset(
      {
        origin,
        destination,
        stop: null,
        timeOpt: this.initialCarIntegratedFormValues.timeOpt,
        arrival: {
          date: this.initialCarIntegratedFormValues.arrival.date,
          time: this.initialCarIntegratedFormValues.arrival.time,
        },
        departure: {
          date: this.initialCarIntegratedFormValues.departure.date,
          time: this.initialCarIntegratedFormValues.departure.time,
        },
        options: {...this.routePlannerForm.controls['options'].value},
        isFirstLeg: this.routePlannerForm.controls["isFirstLeg"].value,
        legOpt: this.routePlannerForm.controls["legOpt"].value,
        legLocation: this.routePlannerForm.controls["legLocation"].value
      },
      { emitEvent: true }
    );

    this.filterStateService.clearFilters()
    const routePlanningFormValues: CarIntegratedForm =
      this.routePlannerForm.value;

      routePlanningFormValues.options = {...this.initialCarIntegratedFormValues.options, transportations: [...initialTransportationsValues]}

    // Keep the loading state true for the second API call
    this.routePlanningService.updateLoadingState(true);

    const routesWithoutFiltersObs$ = this.getRoutePlanningObs(
      routePlanningFormValues,
      routePlanningFormValues.timeOpt,
      false
    );

    routesWithoutFiltersObs$.subscribe({
      next: (routePlanningRes: ServiceResponse<RoutePlanning[]>) => {
        this.handleSuccessfullResponse(
          routePlanningRes,
          routePlanningFormValues
        );
      },
      error: (error) => {
        console.error('Error in route planning without filters:', error);
        this.toggleSearchButton.emit(false);
        this.toogleLoader.emit(false);
        // Reset loading state on error
        this.routePlanningService.updateLoadingState(false);
      },
      complete: () => {
        // Reset loading state when complete
        this.routePlanningService.updateLoadingState(false);
      },
    });
  }

  // Helper method to validate coordinates
  private validateCoordinates(formValues: CarIntegratedForm): boolean {


    // For shared links, we might have addresses with only labels but no coordinates
    // In this case, we'll try to fetch the coordinates
    if (
      formValues.origin?.addressDetails?.label &&
      (!formValues.origin.coordinates ||
        !formValues.origin.coordinates.lat ||
        !formValues.origin.coordinates.lng)
    ) {

      this.fetchCoordinatesForAddress(
        'origin',
        formValues.origin.addressDetails.label
      );
      // We'll return true to allow the form submission to proceed
      // The actual API call will be made after coordinates are fetched
      return true;
    }

    if (
      formValues.destination?.addressDetails?.label &&
      (!formValues.destination.coordinates ||
        !formValues.destination.coordinates.lat ||
        !formValues.destination.coordinates.lng)
    ) {

      this.fetchCoordinatesForAddress(
        'destination',
        formValues.destination.addressDetails.label
      );
      // We'll return true to allow the form submission to proceed
      return true;
    }

    // If we have no labels at all, then we need coordinates
    if (
      !formValues.origin?.addressDetails?.label &&
      (!formValues.origin?.coordinates?.lat ||
        !formValues.origin?.coordinates?.lng)
    ) {
      console.error('Origin has no label and no valid coordinates');
      return false;
    }

    if (
      !formValues.destination?.addressDetails?.label &&
      (!formValues.destination?.coordinates?.lat ||
        !formValues.destination?.coordinates?.lng)
    ) {
      console.error('Destination has no label and no valid coordinates');
      return false;
    }

    return true;
  }

  // Method to fetch coordinates for an address that only has a label
  private fetchCoordinatesForAddress(
    fieldName: 'origin' | 'destination',
    addressLabel: string
  ) {

    // Use the LocationService to search for the address
    this.locationsService.searchAddress(addressLabel).subscribe(
      (response: ServiceResponse<Address[]>) => {
        if (response.data && response.data.length > 0) {
          const address = response.data[0]; // Use the first match


          // Update the form with the found coordinates
          const currentValue = this.routePlannerForm.get(fieldName).value;
          this.routePlannerForm.get(fieldName).setValue({
            ...currentValue,
            coordinates: address.coordinates,
            addressDetails: {
              ...currentValue?.addressDetails,
              label: addressLabel,
            },
          });

          // Decrement the counter for pending coordinate fetches
          this.pendingCoordinateFetches--;


          // If all coordinates have been fetched, resubmit the form
          if (
            this.isFetchingCoordinates &&
            this.pendingCoordinateFetches === 0
          ) {
            this.isFetchingCoordinates = false;

            // Add a small delay to ensure the form is updated
            setTimeout(() => {
              // Check if both origin and destination have coordinates
              const origin = this.routePlannerForm.get('origin').value;
              const destination =
                this.routePlannerForm.get('destination').value;

              if (
                origin?.coordinates?.lat &&
                origin?.coordinates?.lng &&
                destination?.coordinates?.lat &&
                destination?.coordinates?.lng
              ) {

                this.submitRoutePlannerForm();
              } else {
                console.error(
                  'Missing coordinates after fetching, cannot submit form'
                );
                this.toggleSearchButton.emit(false);
                this.toogleLoader.emit(false);
                this.routePlanningService.updateLoadingState(false);
              }
            }, 100);
          }
        } else {
          console.error(
            `No coordinates found for ${fieldName}: ${addressLabel}`
          );

          // Decrement the counter even if we couldn't find coordinates
          this.pendingCoordinateFetches--;

          // If all fetches are complete, reset the loading state
          if (this.pendingCoordinateFetches === 0) {
            this.isFetchingCoordinates = false;
            this.toggleSearchButton.emit(false);
            this.toogleLoader.emit(false);
            this.routePlanningService.updateLoadingState(false);
          }
        }
      },
      (error) => {
        console.error(`Error fetching coordinates for ${fieldName}:`, error);

        // Decrement the counter even if there was an error
        this.pendingCoordinateFetches--;

        // If all fetches are complete, reset the loading state
        if (this.pendingCoordinateFetches === 0) {
          this.isFetchingCoordinates = false;
          this.toggleSearchButton.emit(false);
          this.toogleLoader.emit(false);
          this.routePlanningService.updateLoadingState(false);
        }
      }
    );
  }

  private getRoutePlanningObs(
    routePlanningFormValues: CarIntegratedForm,
    selectedTimeOpt: any,
    isFirstSend: boolean = true
  ) {
    if (isFirstSend) {
      this.resubmittedWithoutFilters = false
    }
    const language = this.routePlanningService.getLanguageForRoute();

    LogService.logInfo(`RoutePlanningForm values`, routePlanningFormValues);

    // Ensure the tab parameter is set for sharing
    this.queryParamsService.setQueryParams({
      tab: eTab.CAR_INTERGRATED,
      saveParams: true,
      isFirstLeg: !!routePlanningFormValues.isFirstLeg,
    });

    // Check if we need to fetch coordinates for origin or destination
    const needsOriginCoordinates =
      routePlanningFormValues.origin?.addressDetails?.label &&
      (!routePlanningFormValues.origin.coordinates ||
        !routePlanningFormValues.origin.coordinates.lat ||
        !routePlanningFormValues.origin.coordinates.lng);

    const needsDestinationCoordinates =
      routePlanningFormValues.destination?.addressDetails?.label &&
      (!routePlanningFormValues.destination.coordinates ||
        !routePlanningFormValues.destination.coordinates.lat ||
        !routePlanningFormValues.destination.coordinates.lng);

    // If we need to fetch coordinates, return a placeholder observable
    // The actual API call will be made after coordinates are fetched
    if (needsOriginCoordinates || needsDestinationCoordinates) {

      // Set flag to indicate we're fetching coordinates
      this.isFetchingCoordinates = true;
      this.pendingCoordinateFetches = 0;

      if (needsOriginCoordinates) {
        this.pendingCoordinateFetches++;
        this.fetchCoordinatesForAddress(
          'origin',
          routePlanningFormValues.origin.addressDetails.label
        );
      }

      if (needsDestinationCoordinates) {
        this.pendingCoordinateFetches++;
        this.fetchCoordinatesForAddress(
          'destination',
          routePlanningFormValues.destination.addressDetails.label
        );
      }

      // Return a placeholder observable
      return of<ServiceResponse<RoutePlanning[]>>({
        data: [],
        success: false,
        message: 'Fetching coordinates...',
      });
    }

    // Standard validation for coordinates
    if (!this.validateCoordinates(routePlanningFormValues)) {
      console.error(
        'Invalid coordinates in form values:',
        routePlanningFormValues
      );
      // Reset the searching flag
      this.isSearching = false;
      // Return an observable that emits an empty result with the correct type
      return of<ServiceResponse<RoutePlanning[]>>({
        data: [],
        success: false,
        message: 'Invalid coordinates',
      });
    }

    // Get the leg address
    const legAddress = this.getAddressObject();
    this.selectedLegAddress = legAddress

    // If we don't have a valid leg address but legOpt is set, try to get a default one
    if (
      (!legAddress || !legAddress.coordinates) &&
      this.routePlannerForm.get('legOpt').value
    ) {
      console.warn('Missing leg address for API call, will try with default');

      // For shared links, we might need to wait for data to load
      // We'll return an observable that will be resolved when data is available
      return new Observable<ServiceResponse<RoutePlanning[]>>((observer) => {
        // Try to get data based on legOpt
        const legOpt = this.routePlannerForm.get('legOpt').value;

        if (legOpt === eLegOptions.TRAIN_STATIONS) {
          this.trainStationsOptions
            .pipe(
              filter((options) => options && options.length > 0),
              map((options) => options[0].value),
              take(1) // Take only the first emission
            )
            .subscribe(
              (defaultAddress) => {
                this.makeApiCall(
                  observer,
                  routePlanningFormValues,
                  selectedTimeOpt,
                  language,
                  defaultAddress
                );
              },
              (error) => {
                console.error('Error getting train station:', error);
                observer.next({
                  data: [],
                  success: false,
                  message: 'Error getting train station',
                });
                observer.complete();
                this.isSearching = false;
              }
            );
        } else if (legOpt === eLegOptions.PARK_AND_RIDE) {
          this.parkingLotsOptions
            .pipe(
              filter((options) => options && options.length > 0),
              map((options) => options[0].value),
              take(1) // Take only the first emission
            )
            .subscribe(
              (defaultAddress) => {
                this.makeApiCall(
                  observer,
                  routePlanningFormValues,
                  selectedTimeOpt,
                  language,
                  defaultAddress
                );
              },
              (error) => {
                console.error('Error getting parking lot:', error);
                observer.next({
                  data: [],
                  success: false,
                  message: 'Error getting parking lot',
                });
                observer.complete();
                this.isSearching = false;
              }
            );
        } else if (legOpt === eLegOptions.ADDRESS) {
          // For ADDRESS option, use the origin as a fallback
          this.makeApiCall(
            observer,
            routePlanningFormValues,
            selectedTimeOpt,
            language,
            routePlanningFormValues.origin
          );
        } else {
          // No valid leg address and can't get a default one
          console.error('Cannot get a valid leg address for API call');
          observer.next({
            data: [],
            success: false,
            message: 'Invalid leg address',
          });
          observer.complete();
          this.isSearching = false;
        }
      });
    }

    const arrivalTime = this.routePlanningService.getArrival(
      selectedTimeOpt,
      routePlanningFormValues
    )

    const departureTime = this.routePlanningService.getDeparture(
      selectedTimeOpt,
      routePlanningFormValues
    )
    this.toggleSearchButton.emit(true);
    this.toogleLoader.emit(true);
    return this.routePlanningService.getRoutesFromApi({
      route: {
        origin: routePlanningFormValues.origin,
        destination: routePlanningFormValues.destination,
        leg: legAddress
          ? {
            address: legAddress,
            isFirstLeg: !!routePlanningFormValues.isFirstLeg,
          }
          : undefined,
        options: {
          ...routePlanningFormValues.options,
          transportations: this.routePlanningService.setTransportations(
            routePlanningFormValues
          ),
          transportationsForInitialUse: routePlanningFormValues.options.transportations,
          arrivalTime,
          departureTime,
        },
      },
      returnedRouteOptions: {
        language: language,
        IsInterModal: true,
        IsVehicleFirst: !!routePlanningFormValues.isFirstLeg,
        isFutureSearch: (this.utilsService.calculateDiffInMinFromPresentTime(departureTime) > 60 || arrivalTime) ? true : false
      },
    });
  }

  // Helper method to make the API call with the given address
  private makeApiCall(
    observer: any,
    routePlanningFormValues: CarIntegratedForm,
    selectedTimeOpt: any,
    language: string,
    legAddress: Address
  ) {
    // Log the API call parameters for debugging


    // Ensure the tab parameter is set for sharing
    this.queryParamsService.setQueryParams({
      tab: eTab.CAR_INTERGRATED,
      saveParams: true,
      isFirstLeg: !!routePlanningFormValues.isFirstLeg,
    });

    this.toggleSearchButton.emit(true);
    this.toogleLoader.emit(true);

    // Ensure we have a valid leg address if legOpt is set
    const legOpt = this.routePlannerForm.get('legOpt').value;
    if (!legAddress && legOpt !== undefined && legOpt !== 0) {
      console.warn('Missing leg address for API call with legOpt set:', legOpt);

      // For ADDRESS option, if we don't have a leg address, use the origin as a fallback
      if (legOpt === eLegOptions.ADDRESS) {
        legAddress = routePlanningFormValues.origin;
      }
    }

    // Final check to ensure we have a valid leg address
    if (!legAddress && legOpt !== undefined && legOpt !== 0) {
      console.error('Still missing leg address after fallback attempts');
      observer.next({
        data: [],
        success: false,
        message: 'Missing leg address',
      });
      observer.complete();
      this.isSearching = false;
      this.toggleSearchButton.emit(false);
      this.toogleLoader.emit(false);
      this.routePlanningService.updateLoadingState(false);
      return;
    }

    this.routePlanningService
      .getRoutesFromApi({
        route: {
          origin: routePlanningFormValues.origin,
          destination: routePlanningFormValues.destination,
          leg: legAddress
            ? {
              address: legAddress,
              isFirstLeg: !!routePlanningFormValues.isFirstLeg,
            }
            : undefined,
          options: {
            ...routePlanningFormValues.options,
            transportations: this.routePlanningService.setTransportations(
              routePlanningFormValues
            ),
            arrivalTime: this.routePlanningService.getArrival(
              selectedTimeOpt,
              routePlanningFormValues
            ),
            departureTime: this.routePlanningService.getDeparture(
              selectedTimeOpt,
              routePlanningFormValues
            ),
          },
        },
        returnedRouteOptions: {
          language: language,
          IsInterModal: true,
          IsVehicleFirst: !!routePlanningFormValues.isFirstLeg,
          isFutureSearch: false
        },
      })
      .subscribe(
        (result) => {
          observer.next(result);
          observer.complete();
          // Reset the searching flag
          this.isSearching = false;
        },
        (error) => {
          console.error('API call error:', error);
          observer.error(error);
          // Reset the searching flag
          this.isSearching = false;
          // Reset loading state
          this.toggleSearchButton.emit(false);
          this.toogleLoader.emit(false);
          this.routePlanningService.updateLoadingState(false);
        }
      );
  }

  private getAddressObject(addressValue?: any): Address {
    if (addressValue) {
      // If an address is provided as a parameter, validate and return it

      // Ensure the address has valid coordinates
      if (
        addressValue.coordinates &&
        addressValue.coordinates.lat &&
        addressValue.coordinates.lng
      ) {
        return addressValue;
      } else {
        console.warn('Provided address has invalid coordinates:', addressValue);
        return null;
      }
    }

    // Otherwise, get the address from the form based on legOpt
    const legOpt = this.routePlannerForm.controls['legOpt'].value;

    let address: Address = null;

    switch (legOpt) {
      case eLegOptions.ADDRESS:
        address = this.routePlannerForm.get('legLocation.legAddress').value;
        // For address option, we need to ensure it has coordinates
        if (
          address &&
          (!address.coordinates ||
            !address.coordinates.lat ||
            !address.coordinates.lng)
        ) {
          console.warn(
            'Leg address is missing coordinates, will try to fetch them'
          );
          // If we have a label but no coordinates, try to fetch them
          if (address.addressDetails && address.addressDetails.label) {
            this.locationsService
              .searchAddress(address.addressDetails.label)
              .pipe(take(1))
              .subscribe(
                (response: ServiceResponse<Address[]>) => {
                  if (response.data && response.data.length > 0) {
                    const foundAddress = response.data[0];


                    // Update the form with the found coordinates
                    this.routePlannerForm
                      .get('legLocation.legAddress')
                      .setValue(
                        {
                          ...address,
                          coordinates: foundAddress.coordinates,
                        },
                        { emitEvent: true }
                      );
                  }
                },
                (error) =>
                  console.error(
                    'Error fetching coordinates for leg address:',
                    error
                  )
              );
          }
        }
        break;
      case eLegOptions.PARK_AND_RIDE:
        address = this.routePlannerForm.get('legLocation.parkAndRideLot').value;
        break;
      case eLegOptions.TRAIN_STATIONS:
        address = this.routePlannerForm.get('legLocation.trainStation').value;
        break;
      default:
        address = null;
    }


    // Validate the address has coordinates
    if (
      !address ||
      !address.coordinates ||
      !address.coordinates.lat ||
      !address.coordinates.lng
    ) {
      console.warn(
        'Address is missing or has invalid coordinates, attempting to fetch default'
      );

      if (legOpt === eLegOptions.TRAIN_STATIONS) {
        // Try to get first train station
        let defaultAddress = null;
        this.trainStationsOptions.pipe(take(1)).subscribe((options) => {
          if (options && options.length > 0) {
            defaultAddress = options[0].value;

          }
        });
        return defaultAddress;
      } else if (legOpt === eLegOptions.PARK_AND_RIDE) {
        // Try to get first parking lot
        let defaultAddress = null;
        this.parkingLotsOptions.pipe(take(1)).subscribe((options) => {
          if (options && options.length > 0) {
            defaultAddress = options[0].value;
          }
        });
        return defaultAddress;
      } else if (legOpt === eLegOptions.ADDRESS) {
        // For address option, if we still don't have valid coordinates,
        // we'll use the origin address as a fallback
        const origin = this.routePlannerForm.get('origin').value;
        if (
          origin &&
          origin.coordinates &&
          origin.coordinates.lat &&
          origin.coordinates.lng
        ) {

          return origin;
        }
      }
    }

    return address;
  }

  override openAutocomplete(
    addressFormControl: FormControl<Address>,
    title: string,
    queryParam: string
  ) {
    this.routePlanningService._componentOverlaySub.next({
      componentType: AddressAutoCompleteComponent,
      data: {
        title: title,
        queryParam: queryParam,
        address: addressFormControl.value,
        saveResultToStorage: true,
        closeCallbackFn: (address: Address) => {
          const addressLabel = address.addressDetails?.label;

          // Ensure the address has coordinates
          if (
            !address.coordinates ||
            !address.coordinates.lat ||
            !address.coordinates.lng
          ) {
            console.warn(
              'Address from autocomplete is missing coordinates, will try to fetch them'
            );

            // If we have a label but no coordinates, try to fetch them
            if (address.addressDetails && address.addressDetails.label) {
              this.locationsService
                .searchAddress(address.addressDetails.label)
                .pipe(take(1))
                .subscribe(
                  (response: ServiceResponse<Address[]>) => {
                    if (response.data && response.data.length > 0) {
                      const foundAddress = response.data[0];


                      // Update the address with the found coordinates
                      const updatedAddress = {
                        ...address,
                        coordinates: foundAddress.coordinates,
                      };

                      // Set the address in the form control
                      addressFormControl.setValue(updatedAddress);

                      // Update query params if needed
                      if (!!queryParam) {
                        // Include the tab parameter when setting query parameters
                        this.queryParamsService.setQueryParams({
                          [queryParam]: addressLabel,
                          tab: eTab.CAR_INTERGRATED,
                          saveParams: true,
                        });

                        // If this is a leg address, also set the coordinates in the query params
                        if (
                          queryParam === 'leg' &&
                          updatedAddress.coordinates
                        ) {
                          this.queryParamsService.setQueryParam(
                            'lll',
                            `${updatedAddress.coordinates.lat},${updatedAddress.coordinates.lng}`
                          );
                        }
                      }
                    } else {
                      console.error(
                        'No coordinates found for address:',
                        address
                      );
                      addressFormControl.setValue(address);

                      if (!!queryParam) {
                        // Include the tab parameter when setting query parameters
                        this.queryParamsService.setQueryParams({
                          [queryParam]: addressLabel,
                          tab: eTab.CAR_INTERGRATED,
                          saveParams: true,
                        });
                      }
                    }
                  },
                  (error) => {
                    console.error(
                      'Error fetching coordinates for address:',
                      error
                    );
                    addressFormControl.setValue(address);

                    if (!!queryParam) {
                      // Include the tab parameter when setting query parameters
                      this.queryParamsService.setQueryParams({
                        [queryParam]: addressLabel,
                        tab: eTab.CAR_INTERGRATED,
                        saveParams: true,
                      });
                    }
                  }
                );
            } else {
              addressFormControl.setValue(address);

              if (!!queryParam) {
                // Include the tab parameter when setting query parameters
                this.queryParamsService.setQueryParams({
                  [queryParam]: addressLabel,
                  tab: eTab.CAR_INTERGRATED,
                  saveParams: true,
                });
              }
            }
          } else {
            // Address already has coordinates, just set it
            addressFormControl.setValue(address);

            if (!!queryParam) {
              // Include the tab parameter when setting query parameters
              this.queryParamsService.setQueryParams({
                [queryParam]: addressLabel,
                tab: eTab.CAR_INTERGRATED,
                saveParams: true,
              });

              // If this is a leg address, also set the coordinates in the query params
              if (queryParam === 'leg' && address.coordinates) {
                this.queryParamsService.setQueryParam(
                  'lll',
                  `${address.coordinates.lat},${address.coordinates.lng}`
                );
              }
            }
          }
        },
      },
    });
  }

  openFilterMenu() {
    const filtersForm = this.routePlannerForm.get('options') as FormGroup;
    const currentTransportationValues = [...filtersForm.value.transportations]
    this.routePlanningService._componentOverlaySub.next({
      componentType: RouteFiltersComponent,
      data: {
        initialFilters: filtersForm.value,
        closeCallbackFn: (filtersResult) => {
          if (filtersResult.reOpen) {
            this.openFilterMenu();
          }
          else {
            if (filtersResult.applyFilters) {
              const routePlanningFiltersFormValue =
                filtersResult.value as SourceDestinationFiltersForm;

              // Update the local form value.
              this.applyFilters(routePlanningFiltersFormValue);

              // IMPORTANT: Update the FilterStateService so that subsequent screens
              // receive the applied (non-default) filters instead of the saved default.
              // this.filterStateService.setFiltersTransient(
              //   routePlanningFiltersFormValue
              // );
            } else {
              this.routePlannerForm.controls['options'].patchValue({ ...filtersForm.value, transportations: [...currentTransportationValues] })
            }
          }
          if (filtersResult.isDefaultFilters) {
            this.appliedFilters = false;
          }
        },
      },
    });
  }

  private applyFilters(
    routePlanningFiltersFormValue: SourceDestinationFiltersForm
  ) {
    this.appliedFilters = !!routePlanningFiltersFormValue;
    this.routePlannerForm.patchValue(
      { options: routePlanningFiltersFormValue },
      {
        emitEvent: true,
      }
    );
    this.routePlannerForm.controls['options'].markAsDirty();
  }

  private setAddressQueryParam(
    address: Address,
    labelQueryParam: string,
    coordinatesQueryParam: string
  ) {
    const queryParam = {};

    queryParam[labelQueryParam] = address?.addressDetails?.label;
    queryParam[coordinatesQueryParam] = !!address
      ? `${address.coordinates.lat}_${address.coordinates.lng}`
      : null;

    this.queryParamsService.setQueryParams(queryParam);
  }

  private syncAddressFromQueryParam(
    queryParams: Record<string, unknown>,
    labelKey: string,
    coordsKey: string,
    formControlName: 'origin' | 'destination' | 'legLocation.legAddress'
  ): void {
    const label = queryParams[labelKey] as string | undefined;
    const coordsStr = queryParams[coordsKey] as string | undefined;
    if (!label || !coordsStr) return;
    const parts = coordsStr.split('_');
    if (
      parts.length !== 2 ||
      isNaN(parseFloat(parts[0])) ||
      isNaN(parseFloat(parts[1]))
    ) {
      return;
    }
    const newLat = parseFloat(parts[0]);
    const newLng = parseFloat(parts[1]);
    const control = this.routePlannerForm.get(formControlName);
    const current = control?.value as Address;
    if (current?.coordinates?.lat === newLat && current?.coordinates?.lng === newLng) {
      return;
    }
    control?.patchValue({
      addressDetails: { label },
      coordinates: { lat: newLat, lng: newLng },
    });
  }

  isFirstLeg() {
    return this.routePlannerForm.controls['isFirstLeg'].value
  }
}
